import { Typography, InputLabel } from '@mui/material'

export const LabelGroup: React.FC<{ children: string | undefined }> = ({ children }) => (
    <InputLabel htmlFor={children}>
        <Typography variant="h3" color={'text.secondary'} sx={{ mb: '6px' }}>
            {children}
        </Typography>
    </InputLabel>
)
